<template>
  <center>
    <div style="height: 15vh;"></div>
    <h1>Discover XSINT’s OSINT Capabilities</h1>
            
    <p style="text-align: center;">Maximize your investigations: XSINT connects over 1,300 sites and databases.</p>
    <div id="tools_card" >


            <br>
            <v-card-item>
                <h4 class="textb">I - Osint Automation</h4>
                <p>
                  The osint automation makes it possible to find accounts associated with email addresses/phone numbers on multiple websites. 
                  <br>He also looks for information with dorks on different search engines and finds on which site the email address/phone number is registered.
                  <br><br>
                  This is an up-to-date table of applications and sites where it can find information by email addresses:
                </p>        
            </v-card-item>
            <v-card-item>
              <v-data-table
              :headers="headers_modules"
              :items="modules"
              item-value="name"
              items-per-page="5"
              width="100%"
            >
              <template v-slot:[`item.module_picture`]="{ item }">
                <v-img
                  :src="item.module_picture"
                  alt="module logo"
                  max-height="30"
                  max-width="30"
                ></v-img>
              </template>
              <template v-slot:[`item.response_fields`]="{ item }">
              <div style="display: flex; flex-wrap: wrap; gap: 8px; padding: 8px;">
                <v-chip
                  v-for="(field, index) in item.response_fields.split(',')"
                  :key="index"
                  class="chip-item"
                >
                  {{ field.trim() }}
                </v-chip>
              </div>
            </template>
          </v-data-table>
        </v-card-item>
        <v-card-item>
          <p>This is an up-to-date table of applications and sites where it can find information by phone: </p><br>
              <v-data-table
              :headers="headers_phone_modules"
              :items="phone_modules"
              item-value="name"
              v-model:items-per-page="itemsPerPage"
              width="100%"
            >
              <template v-slot:[`item.module_picture`]="{ item }">
                <v-img
                  :src="item.module_picture"
                  alt="module logo"
                  max-height="30"
                  max-width="30"
                ></v-img>
              </template>
              <template v-slot:[`item.response_fields`]="{ item }">
              <div style="display: flex; flex-wrap: wrap; gap: 8px; padding: 8px;">
                <v-chip
                  v-for="(field, index) in item.response_fields.split(',')"
                  :key="index"
                  class="chip-item"
                >
                  {{ field.trim() }}
                </v-chip>
              </div>
            </template>
          </v-data-table>
        </v-card-item>
        <v-card-item>
        <br>
                <h4 class="textb">II - Xsint Intelligence Browser</h4>
                <p>
                  Xsint Intelligence is a search engine like google or better duckduckgo but it detects and indexes email addresses, phone numbers, ip addresses...<br>The software a lot of detects documents, downloads and references it can be any type of data.<br>Below are the data leaks that the software was able to find
                </p>        
            </v-card-item>
            <v-card-item>
              <v-data-table
              :headers="headers_databases"
              :items="databases"
              item-value="name"
              items-per-page="3"
            >
              <template v-slot:[`item.picture`]="{ item }">
                <v-img
                  :src="item.picture"
                  alt="module logo"
                  max-height="30"
                  max-width="30"
                ></v-img>
              </template>
              <template v-slot:[`item.compromised_informations`]="{ item }">
              <div style="display: flex; flex-wrap: wrap; gap: 8px; padding: 8px;">
                <v-chip
                  v-for="(field, index) in item.compromised_informations.split(',')"
                  :key="index"
                  class="chip-item"
                >
                  {{ field.trim() }}
                </v-chip>
              </div>
            </template>
          </v-data-table>
        </v-card-item>


    </div>
  </center>
</template>
<script setup>
import { useHead } from '@vueuse/head';

useHead({
  title: 'Discover XSINT’s OSINT Capabilities | XSINT Intelligence',
  meta: [  
    { name: 'keywords', content: 'About us, about, informations, XSINT, XSINT Intelligence, xsint' },
    
    { property: 'og:title', content: 'Discover XSINT’s OSINT Capabilities | XSINT Intelligence' },
    { name: 'twitter:title', content: 'Discover XSINT’s OSINT Capabilities | XSINT Intelligence' },

    { name: 'description', content: 'Maximize your investigations with XSINT: Seamlessly connect to over 1,300 sites and databases to uncover critical insights fast.' },
    { property: 'og:description', content: 'Maximize your investigations with XSINT: Seamlessly connect to over 1,300 sites and databases to uncover critical insights fast.' },
    { name: 'twitter:description', content: 'Maximize your investigations with XSINT: Seamlessly connect to over 1,300 sites and databases to uncover critical insights fast.' },

    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://www.xsint-intelligence.com/about-us' },
    { name: 'robots', content: 'index, follow' },
    { name: 'author', content: 'XSINT Intelligence' }
  ]
});
</script>
<script>
import { mapGetters } from 'vuex';
export default {

  data(){
      return {
        size: window.innerWidth,
        itemsPerPage: 5,
        headers_modules: [],
        headers_databases: [],
        databases : [],
        modules: [],
        phone_modules: [],
        headers_phone_modules: []
    } 
  },
  created() {
    this.getHeaders();
    this.getModules();
    this.getDatabases();
    this.getPhoneModules();
  }, 
  computed: {
    ...mapGetters(['backend']),
  },
  methods: {
    getHeaders(){
      let headers_modules = [
          { title: 'Picture', align: 'start', key: 'module_picture' },
          { title: 'Name', key: 'module_name' },
          { title: 'Avaliable', key: 'avaliable' }
      ];
      if (this.size >= 600) {
        headers_modules.splice(2, 0, { title: 'Response Fields', key: 'response_fields' });
        //headers_modules.splice(3, 0, { title: 'Reliability', key: 'reliability' });
        //headers_modules.splice(4, 0, { title: 'Dangerous', key: 'dangerous' });        
      }

      let headers_databases = [
            {title: 'Picture',align: 'start',key: 'picture',},
            { title: 'Name', key: 'name'},
            { title: 'Records', key: 'records'},
      ]

      if (this.size >= 600) {
        headers_databases.splice(3, 0, { title: 'Description', key: 'description'},);
        headers_databases.splice(4, 0,{ title: 'Compromised Informations', key: 'compromised_informations'},);        
      }
      
      this.headers_modules = headers_modules;
      this.headers_databases = headers_databases;
      this.headers_phone_modules = headers_modules
    },
    breakLines(description) {
      return description.replace(/\n/g, '<br>');
    },
    async getModules(){
      let response = await this.$axios.get(`${this.backend}/api/informations/modules`);
      let modules = response.data;

      // Étape 2: Transformer les données en remplaçant 'true' par 'yes' et 'false' par 'no'
      this.modules = Object.keys(modules).map(key => {
        let module = modules[key];
        return {
          ...module,
          // Remplacer 'true' par 'yes' et 'false' par 'no' dans la propriété 'avaliable'
          avaliable: module.avaliable ? 'yes' : 'no',
        };
    });
    },
    async getPhoneModules(){
      let phone_modules = await this.$axios.get(`${this.backend}/api/informations/phone_modules`)
      let modules = phone_modules.data;

      // Étape 2: Transformer les données en remplaçant 'true' par 'yes' et 'false' par 'no'
      this.phone_modules = Object.keys(modules).map(key => {
        let module = modules[key];
        return {
          ...module,
          // Remplacer 'true' par 'yes' et 'false' par 'no' dans la propriété 'avaliable'
          avaliable: module.avaliable ? 'yes' : 'no',
        };
      })
    },
    async getDatabases(){
      let databases = await this.$axios.get(`${this.backend}/api/informations/databases`)
      this.databases = databases.data
    },
  },

}
</script>

<style scoped>
h1{
  font-size: 55px;
}

#tools_card {
  margin-top: 5%;
  width: 100%;
  background-color: rgba(15, 15, 15, 0.541);
}


@media only screen and (min-width: 600px) {
#tools_card {
  margin-top: 2%;
  width: 75%;

}
}

p,h4{
  text-align: left;
}
#transparent{
  background-color: transparent !important;
  box-shadow: none !important;
}

.textb{
  color:rgb(60, 161, 255)
}

p{
  font-size: 20px;
}
</style>